/**
 * @generated SignedSource<<a3e94e59f97e86d401543cd0a94c9b0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "terminalId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "terminalId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gtfsId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alertSeverityLevel",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveStartDate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveEndDate",
  "storageKey": null
},
v10 = {
  "kind": "Literal",
  "name": "startTime",
  "value": 0
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceDay",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledDeparture",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "platformCode",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Stop",
  "kind": "LinkedField",
  "name": "stop",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v13/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stopRoutes_TerminalPageContent_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Stop",
        "kind": "LinkedField",
        "name": "station",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TerminalPageContentContainer_station"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stopRoutes_TerminalPageContent_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Stop",
        "kind": "LinkedField",
        "name": "station",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vehicleMode",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Route",
            "kind": "LinkedField",
            "name": "routes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "types",
                "value": [
                  "STOP",
                  "ROUTES"
                ]
              }
            ],
            "concreteType": "Alert",
            "kind": "LinkedField",
            "name": "alerts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alertEffect",
                "storageKey": null
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": "alerts(types:[\"STOP\",\"ROUTES\"])"
          },
          {
            "alias": "futureStoptimes",
            "args": [
              {
                "kind": "Literal",
                "name": "numberOfDepartures",
                "value": 1
              },
              {
                "kind": "Literal",
                "name": "omitCanceled",
                "value": true
              },
              (v10/*: any*/),
              {
                "kind": "Literal",
                "name": "timeRange",
                "value": 7776000
              }
            ],
            "concreteType": "Stoptime",
            "kind": "LinkedField",
            "name": "stoptimesWithoutPatterns",
            "plural": true,
            "selections": [
              (v11/*: any*/)
            ],
            "storageKey": "stoptimesWithoutPatterns(numberOfDepartures:1,omitCanceled:true,startTime:0,timeRange:7776000)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Stop",
            "kind": "LinkedField",
            "name": "stops",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Pattern",
                "kind": "LinkedField",
                "name": "patterns",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Route",
                    "kind": "LinkedField",
                    "name": "route",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "stoptimes",
            "args": [
              {
                "kind": "Literal",
                "name": "numberOfDepartures",
                "value": 100
              },
              {
                "kind": "Literal",
                "name": "omitCanceled",
                "value": false
              },
              (v10/*: any*/),
              {
                "kind": "Literal",
                "name": "timeRange",
                "value": 43200
              }
            ],
            "concreteType": "Stoptime",
            "kind": "LinkedField",
            "name": "stoptimesWithoutPatterns",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "realtimeState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "realtimeDeparture",
                "storageKey": null
              },
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "realtimeArrival",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scheduledArrival",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "realtime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pickupType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dropoffType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headsign",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stopPositionInPattern",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Stop",
                "kind": "LinkedField",
                "name": "stop",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v2/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "trip",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "directionId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tripHeadsign",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Stop",
                    "kind": "LinkedField",
                    "name": "stops",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Pattern",
                    "kind": "LinkedField",
                    "name": "pattern",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Route",
                        "kind": "LinkedField",
                        "name": "route",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shortName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "longName",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Agency",
                            "kind": "LinkedField",
                            "name": "agency",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Alert",
                            "kind": "LinkedField",
                            "name": "alerts",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              (v9/*: any*/),
                              (v8/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Stop",
                        "kind": "LinkedField",
                        "name": "stops",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v2/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Stoptime",
                    "kind": "LinkedField",
                    "name": "stoptimes",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Stoptime",
                    "kind": "LinkedField",
                    "name": "stoptimesForDate",
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "stoptimesWithoutPatterns(numberOfDepartures:100,omitCanceled:false,startTime:0,timeRange:43200)"
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25c41603a4d07f27074734a63c4b413b",
    "id": null,
    "metadata": {},
    "name": "stopRoutes_TerminalPageContent_Query",
    "operationKind": "query",
    "text": "query stopRoutes_TerminalPageContent_Query(\n  $terminalId: String!\n) {\n  station(id: $terminalId) {\n    ...TerminalPageContentContainer_station\n    id\n  }\n}\n\nfragment DepartureListContainer_stoptimes on Stoptime {\n  realtimeState\n  realtimeDeparture\n  scheduledDeparture\n  realtimeArrival\n  scheduledArrival\n  realtime\n  serviceDay\n  pickupType\n  dropoffType\n  headsign\n  stopPositionInPattern\n  stop {\n    gtfsId\n    id\n    code\n    platformCode\n  }\n  trip {\n    gtfsId\n    directionId\n    tripHeadsign\n    stops {\n      id\n    }\n    pattern {\n      route {\n        gtfsId\n        shortName\n        longName\n        mode\n        type\n        color\n        agency {\n          name\n          id\n        }\n        alerts {\n          alertSeverityLevel\n          effectiveEndDate\n          effectiveStartDate\n          id\n        }\n        id\n      }\n      code\n      stops {\n        gtfsId\n        code\n        id\n      }\n      id\n    }\n    stoptimes {\n      scheduledDeparture\n      stop {\n        gtfsId\n        platformCode\n        id\n      }\n    }\n    stoptimesForDate {\n      serviceDay\n      scheduledDeparture\n      stop {\n        gtfsId\n        platformCode\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment TerminalPageContentContainer_station on Stop {\n  vehicleMode\n  code\n  url\n  routes {\n    gtfsId\n    mode\n    type\n    id\n  }\n  alerts(types: [STOP, ROUTES]) {\n    alertEffect\n    alertSeverityLevel\n    effectiveStartDate\n    effectiveEndDate\n    id\n  }\n  futureStoptimes: stoptimesWithoutPatterns(startTime: 0, timeRange: 7776000, numberOfDepartures: 1, omitCanceled: true) {\n    serviceDay\n  }\n  stops {\n    patterns {\n      route {\n        mode\n        id\n      }\n      id\n    }\n    id\n  }\n  stoptimes: stoptimesWithoutPatterns(startTime: 0, timeRange: 43200, numberOfDepartures: 100, omitCanceled: false) {\n    serviceDay\n    ...DepartureListContainer_stoptimes\n  }\n}\n"
  }
};
})();

node.hash = "9dc7026ab0effdbd079a8de5a34f6ab3";

export default node;
